import PropTypes from 'prop-types';

import { Colors } from '@spotahome/ui-library';

const theme = {
  base: Colors.primary,
  light: 'white',
  interaction: Colors.interaction,
  interactionDark: Colors['interaction-dark']
};

const OtherRooms = props => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7ZM6.22647 3.28125H7.75689V6.24313H10.7188V7.77355H7.75689V10.7188H6.22647V7.77355H3.28125V6.24313H6.22647V3.28125Z"
      fill={theme[props.theme]}
    />
  </svg>
);

OtherRooms.propTypes = {
  theme: PropTypes.oneOf(['base', 'light', 'interaction', 'interactionDark'])
};

OtherRooms.defaultProps = {
  theme: 'base'
};
export default OtherRooms;
